import { advertiserActivityNavObj } from "app/components/sidebar3/secondary-side-bar/secondary-bar-nav-obj/ad-intelligence/advertiserActivityNavObj";
import { publisherAnalysisNavObj } from "app/components/sidebar3/secondary-side-bar/secondary-bar-nav-obj/ad-intelligence/publisherAnalysisNavObj";
import { segmentAnalysisNavObj } from "app/components/sidebar3/secondary-side-bar/secondary-bar-nav-obj/competition/segmentAnalysisNavObj";
import { websiteAnalysisNavObj } from "app/components/sidebar3/secondary-side-bar/secondary-bar-nav-obj/competition/websiteAnalysisNavObj";
import { industryAnalysisNavObj31 } from "app/components/sidebar3/secondary-side-bar/secondary-bar-nav-obj/market-research/industryAnalysisNavObj31";
import { getSICompanyOverviewNavObj } from "app/components/sidebar3/secondary-side-bar/secondary-bar-nav-obj/sales/siCompanyOverviewNavObj";
import { backlinksAnalysisNavObj } from "app/components/sidebar3/secondary-side-bar/secondary-bar-nav-obj/search-intelligence/backlinksAnalysisNavObj";
import { keywordResearchNavObj } from "app/components/sidebar3/secondary-side-bar/secondary-bar-nav-obj/search-intelligence/keywordResearchNavObj";
import { searchTrackingNavObj } from "app/components/sidebar3/secondary-side-bar/secondary-bar-nav-obj/search-intelligence/SearchTrackingNavObj";
import type { INavItem } from "app/components/sidebar3/types";

export type SidebarAccess = {
    hidden: boolean;
    locked: boolean;
};

export type SidebarAccessMap = ReadonlyMap<string, SidebarAccess>;

type NavObjFactory = () => { navList: INavItem[] };

type SidebarAccessEntry = [state: string, access: SidebarAccess];

const SIDEBAR_NAV_OBJ_FACTORIES: readonly NavObjFactory[] = [
    websiteAnalysisNavObj,
    segmentAnalysisNavObj,
    keywordResearchNavObj,
    backlinksAnalysisNavObj,
    searchTrackingNavObj,
    publisherAnalysisNavObj,
    advertiserActivityNavObj,
    industryAnalysisNavObj31,
    getSICompanyOverviewNavObj,
];

const OPEN: SidebarAccess = { hidden: false, locked: false };

const safeNavList = (factory: NavObjFactory): INavItem[] => {
    try {
        const { navList } = factory();
        return Array.isArray(navList) ? navList : [];
    } catch {
        return [];
    }
};

const mergeAccess = (a: SidebarAccess, b: SidebarAccess): SidebarAccess => ({
    hidden: a.hidden && b.hidden,
    locked: a.locked && b.locked,
});

const collectEntries = (item: INavItem, inherited: SidebarAccess): SidebarAccessEntry[] => {
    const access: SidebarAccess = {
        hidden: inherited.hidden || item.hidden === true,
        locked: inherited.locked || item.lockIcon === true,
    };

    const childEntries = (item.subItems ?? []).flatMap((sub) => collectEntries(sub, access));

    return item.state ? [[item.state, access], ...childEntries] : childEntries;
};

export const getSidebarAccessMap = (): SidebarAccessMap =>
    SIDEBAR_NAV_OBJ_FACTORIES.flatMap(safeNavList)
        .flatMap((item) => collectEntries(item, OPEN))
        .reduce<Map<string, SidebarAccess>>((map, [state, access]) => {
            const existing = map.get(state);

            map.set(state, existing ? mergeAccess(existing, access) : access);

            return map;
        }, new Map());
